import { apiClient } from './apiClient'

export type CustomerType = 'PARTICULIER' | 'ENTREPRISE'

export interface CustomerResponse {
  id: string
  type: CustomerType
  name: string
  phone: string | null
  address: string | null
  taxId: string | null
  active: boolean
}

export interface CreateCustomerRequest {
  type: CustomerType
  name: string
  phone?: string
  address?: string
  taxId?: string
}

export type UpdateCustomerRequest = CreateCustomerRequest

/** Client typé du module customer (annuaire client) — cf. boutiklic-core CustomerController,
 *  doc TVA §7 (question ouverte tranchée "oui" : un vrai annuaire client, pas seulement snapshotté
 *  sur les devis/factures). */
export const customerApi = {
  search: (query?: string) =>
    apiClient.get<CustomerResponse[]>(`/customers${query ? `?query=${encodeURIComponent(query)}` : ''}`),

  getById: (customerId: string) => apiClient.get<CustomerResponse>(`/customers/${customerId}`),

  create: (request: CreateCustomerRequest) => apiClient.post<CustomerResponse>('/customers', request),

  update: (customerId: string, request: UpdateCustomerRequest) =>
    apiClient.put<CustomerResponse>(`/customers/${customerId}`, request),

  deactivate: (customerId: string) => apiClient.delete<void>(`/customers/${customerId}`),
}
